// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/containers/SourcesStack.scss
// module id = 1333
// module chunks = 0